'use strict';
var parent = require('../../stable/set/difference');
require('../../modules/esnext.set.difference.v2');

module.exports = parent;
